import { TrustSignalsBadgeContainer } from '@dbt-labs/metadata-shared';
import { CellContext } from '@dbt-labs/sourdough';

import { HealthIssueType, SourceHealthIssueType } from '@/__generated__/graphql';

type ModelTrustSignalCellProps<TData extends object> = CellContext<
  TData,
  (HealthIssueType | SourceHealthIssueType)[]
> & {
  additionalMetadata?: {
    linkMapping: Record<string, { to: string; state?: {} }>;
  };
};

export const ModelTrustSignalCell = <TData extends object>({
  getValue,
  additionalMetadata,
}: ModelTrustSignalCellProps<TData>) => {
  const value = getValue();

  return (
    <TrustSignalsBadgeContainer
      trustSignals={{ healthIssues: value, additionalMetadata }}
      resourceType="model"
      shouldRenderStateHeader={true}
    />
  );
};
